require('./map-clients');
require('./map-defendants');

window.makeInteractiveMap = (id) =>  {
	let myMap = new ymaps.Map(id, {
		center: [59.264636, 83.311086],
		zoom: 4,
		controls: ['smallMapDefaultSet'],
		type: 'yandex#map',
	}, {
		restrictMapArea: [
			[1.0, -25.0],
			[77.73, 180.0]
		],
		scrollZoom: false,
		suppressMapOpenBlock: true
	});

	myMap.controls.remove('searchControl');
	myMap.controls.remove('trafficControl');
	myMap.controls.remove('typeSelector');
	myMap.controls.remove('fullscreenControl');
	myMap.controls.remove('geolocationControl');
	myMap.behaviors.disable('scrollZoom');

	const params = {theme: 'grayscale'}; // Выбираем тему

	if (params.theme === 'grayscale') {
		myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%) invert(0)';
	} else {
		let MAP = 'custom#' + params.theme;

		ymaps.layer.storage.add(MAP, function mapLayer() {
			return new ymaps.Layer(
				'https://core-renderer-tiles.maps.yandex.net/tiles?l=map' +
				(params.theme === 'dark' ? '&theme=dark' : '') +
				'&%c&%l'
			);
		});

		ymaps.mapType.storage.add(MAP, new ymaps.MapType(params.theme, [MAP]));
		myMap.setType(MAP);
	}

	return myMap;
};

window.interactiveMapDefaultColors = {
	country: {
		fillColor: 'rgba(162, 137, 96, 0.15)',
		strokeColor: 'rgba(162, 137, 96, 1)',
	},
	region: {
		fillColor: 'rgba(66, 102, 152, 0.15)',
		strokeColor: 'rgba(66, 102, 152, 0.50)',
	},
};

window.interactiveMapHoverColors = {
	country: {
		fillColor: 'rgba(162, 137, 96, 0.7)',
		strokeColor: 'rgba(162, 137, 96, 0.3)',
	},
	region: {
		fillColor: 'rgba(66, 102, 152, 0.35)',
		strokeColor: '#426698',
	},
};
